import type { JSX } from 'preact';
import { cn } from '../lib/cn';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md' | 'lg';

interface Props extends JSX.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const variantClasses: Record<Variant, string> = {
  primary: 'bg-brand-500 text-white hover:bg-brand-600 focus:ring-brand-500',
  secondary:
    'bg-surface text-surface-fg border border-surface-muted/40 hover:bg-surface-muted/10',
  ghost: 'bg-transparent text-surface-fg hover:bg-surface-muted/10',
  danger: 'bg-danger-500 text-white hover:brightness-95 focus:ring-danger-500',
};

const sizeClasses: Record<Size, string> = {
  sm: 'h-8 px-3 text-sm',
  md: 'h-10 px-4 text-base',
  lg: 'h-12 px-6 text-lg',
};

export function Button({
  variant = 'primary',
  size = 'md',
  class: cls,
  className,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      class={cn(
        'inline-flex items-center justify-center rounded font-medium transition',
        'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-surface',
        'disabled:opacity-50 disabled:pointer-events-none',
        variantClasses[variant],
        sizeClasses[size],
        cls as string | undefined,
        className as string | undefined,
      )}
    />
  );
}
